/* Poprawki rozwijanej listy rozmiaru (<swatch-dropdown>).

   1. Motyw dopisuje klase "active" tylko na kontenerze listy, a CSS motywu
      oczekuje jej na samym <swatch-dropdown> - przez to ramka pola nie
      ciemniala po otwarciu i lista nie byla dosunieta do pola.
   2. Klikniecie etykiety rozmiaru wywoluje DRUGIE klikniecie na ukrytym
      <input type=radio>. Handler motywu przelaczal wiec liste dwa razy i po
      wyborze rozmiaru lista otwierala sie z powrotem. Teraz po kliknieciu
      rozmiaru liste zamykamy jawnie.
   3. Brakowalo zamykania listy klikiem poza nia i klawiszem Escape.
   4. Klikniecie w pasek przewijania lub puste miejsce listy zamykalo liste.
   5. Po zmianie wariantu motyw dociaga nowa wersje sekcji przez fetch i
      podmienia HTML. Przy szybkim klikaniu kilka zadan leci rownolegle i
      potrafi zostawic otwarta, ale PUSTA liste. Pilnujemy tego: otwarta
      lista bez zadnej pozycji jest zamykana, a kazde przerysowanie
      variant-radios-detail zamyka listy.

   Wszystko na delegacji zdarzen, wiec dziala tez po przerysowaniu sekcji. */
(function () {
  if (window.__sizeDropdownFix) return;
  window.__sizeDropdownFix = true;

  var OPEN = 'active';

  function panelOf(dd) {
    return dd.querySelector('.select-custom__content');
  }

  function all() {
    return document.querySelectorAll('swatch-dropdown');
  }

  function close(dd) {
    if (!dd) return;
    var panel = panelOf(dd);
    if (panel) panel.classList.remove(OPEN);
    dd.classList.remove(OPEN);
  }

  function closeAll(except) {
    all().forEach(function (dd) {
      if (dd !== except) close(dd);
    });
  }

  /* Otwarta lista bez pozycji = niedokonczone przerysowanie. Zamykamy, zeby
     klient nie zobaczyl pustego panelu. */
  function dropEmpty() {
    all().forEach(function (dd) {
      var panel = panelOf(dd);
      if (!panel || !panel.classList.contains(OPEN)) return;
      if (dd.querySelectorAll('swatch-dropdown-item').length === 0) close(dd);
    });
  }

  function syncAll() {
    all().forEach(function (dd) {
      var panel = panelOf(dd);
      if (panel) dd.classList.toggle(OPEN, panel.classList.contains(OPEN));
    });
    dropEmpty();
  }

  /* Klik w pasek przewijania lub w puste miejsce listy nie ma jej zamykac.
     Zatrzymujemy tylko zdarzenia, ktore nie dotycza zadnej pozycji listy. */
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var panel = t.closest('.select-custom__content');
      if (!panel || !panel.closest('swatch-dropdown')) return;
      if (!t.closest('swatch-dropdown-item')) e.stopPropagation();
    },
    true
  );

  /* setTimeout, bo handler motywu przelacza klase dopiero po nas, a klikniecie
     etykiety generuje jeszcze jedno klikniecie (na ukrytym radio). */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var closest = t && t.closest ? t.closest.bind(t) : null;
    var dd = closest ? closest('swatch-dropdown') : null;
    var item = closest ? closest('swatch-dropdown-item') : null;
    setTimeout(function () {
      if (!dd) {
        closeAll();
        return;
      }
      if (item) {
        close(dd);
        return;
      }
      syncAll();
      if (dd.classList.contains(OPEN)) closeAll(dd);
    }, 0);
  });

  /* Zmiana wariantu uruchamia przerysowanie sekcji - listy maja byc zamkniete. */
  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('swatch-dropdown')) return;
      closeAll();
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAll();
  });

  /* Po kazdym przerysowaniu selektora wariantow sprawdzamy stan list. */
  var pending = null;
  function watch() {
    var host = document.querySelector('.product-detail__information');
    if (!host || host.dataset.sizeFixWatched) return;
    host.dataset.sizeFixWatched = '1';
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(syncAll, 60);
    }).observe(host, { childList: true, subtree: true });
  }

  function init() {
    watch();
    syncAll();
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
